import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../services/api.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { CommonEventService } from '../services/common-event.service';
import * as $ from 'jquery';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-quote-details',
  templateUrl: './quote-details.component.html',
  styleUrls: ['./quote-details.component.css']
})
export class QuoteDetailsComponent {
  electricalTestingPrice :any;
  fabSubtotalWithoutElectricalTesting : any;
  fabSubTotal:any;
  fabTotal : any;
  fabTotalWithoutElectricalTesting:any;
  fabSubTotalWithElectricalTesting:any;
  fabTotalWithElectricalTesting:any;
  savedPartNum :any;
  savedPartRevision : any;
  savedSurfaceFinish : any;
  savedMaterial :any;
  savedBoardDimensions : any;
  savedLayer :any;
  savedItar :any;
  electricalTesting:any;
  quoteDetailList:any= {};
  closeResult: string = '';
  elecTestChk:any;
  clickCheckFrom:any;
  qtyIndvBoardsArray:any;
  totalQuoteValue:any;
  totalQuoteValueWithoutElectricTesting:any;
  totalQuoteValueWithElectricTesting:any;
  testingValFromApi:any;
  codeExpire:boolean =false;
  quoteBOM:any;
  previousFileName: string = '';
  curentFileUploadedName:any;
  fisrtSavedMessageText: any;
  remainingSaveQuoteSentence:any;
  IsAllowedFileExtension:boolean = true;
  missingFiles:any = [];
  missingListFiles :any =[];
  disableAssemblyErrorProceed:boolean = false;
  changedNoOfBoards:any;
  bomUploadSec:boolean = false;
  bomFileData :any;
  selectedSheetNum:any;
  sheetsArray :any =[];
  showNumberOfSheets : boolean = false;
  autoMappingData:any;
  mainRowArrayObj:any = {
    'labelsArray' : [],
    'bomOneMapArrayData' : []
  };
  disableAutomapProceed : boolean = false;
  newPcbTurnTime: any;
  newPcbOrgTurnTime:any;
  newAssemblyQty: any;
  newAssemblyTurnTime: any;
  newChangeQuoteId:any;
  greaterBomResponse=[];
  changedPcbTT:any;
  newPcbQty:any;
  checkBomAutoUploaded:any;
  checkBomAdded:boolean = false;
  checkBomReuploaded:boolean = false;
  bomChanged:boolean = false;
  mappingArray:any=[];
  selectedColMapValList:any=[];
  mapValueArray:any=[];
  bomMappingKeyObj:any={};
  flowActivityId:any='';
  reQuoteContentObj :any='';

  //related login start
  constructor(
    private router: Router,public apiService:ApiService,private modalService: NgbModal,public commonService : CommonEventService,
    private activatedRoute: ActivatedRoute,) {
      this.commonService.commonMainObj.onlyPcb = true
      // $('#guestSaveQuoteProcess').hide();
      // if(localStorage.getItem('apiSerDataObj') && localStorage.getItem('commonDataObj')){
      //   $('#guestSaveQuoteProcess').show();
      //   let apiObj:any = localStorage.getItem('apiSerDataObj')
      //   let commonObj:any = localStorage.getItem('commonDataObj')
      //   this.apiService.apiMainObj = JSON.parse(apiObj) 
      //   this.commonService.commonMainObj = JSON.parse(commonObj)
      // }
      
  }

  ngOnInit(): void {
    if(localStorage.getItem('apDtId')){
      this.apiService.getAppStoreData(localStorage.getItem('apDtId')).subscribe((storeAppDataObj) =>{
        let strAppDt = JSON.parse(storeAppDataObj.fileData)
        this.apiService.apiMainObj = JSON.parse(strAppDt.data['apiSerDataObj'])
        this.commonService.commonMainObj = JSON.parse(strAppDt.data['commonDataObj'])
        this.reQuoteContentObj = strAppDt.data['contentObj']
        if(this.commonService.commonMainObj.savedBomFileName){
          this.apiService.getSavedBomFIleData(this.commonService.commonMainObj.savedBomFileName).subscribe((data) =>{
            this.commonService.commonMainObj.retrivedBomFileDta =data.body;
          }, error =>{
            console.log('Bom file saving Error1', error);
          });
        }
        this.userSessionCheck();
        this.guestUserFlowInitFn();
        this.commonService.loadingShow();
        setTimeout(() => {
          if(!this.commonService.commonMainObj.invalidUser){
            let confirmQuoteData={
              "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
            }
            this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
            this.apiService.updateDetailsToDashboard(this.flowActivityId,confirmQuoteData,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas)=>{
            },err=>{
              console.log(err)
            });
          }
        }, 1000);
        setTimeout(()=>{
          this.activatedRoute.queryParams.subscribe(params => {
            if(params['data']){
              this.wantReQuote(this.commonService.commonMainObj.reQuoteEnable == true ? 'reQuoteYes':'reQuoteNo');
              this.commonService.commonMainObj.selectedFabQuantity = this.commonService.commonMainObj.newPcbQty;
              this.newPcbQty = this.commonService.commonMainObj.newPcbQty;
              this.newPcbOrgTurnTime = this.commonService.commonMainObj.newPcbOrgTurnTime;
              this.commonService.commonMainObj.selectedFabTurntimeVal = this.commonService.commonMainObj.newPcbOrgTurnTime.split(' ')[0];
              this.commonService.commonMainObj.selectedFabOrgTurntime = this.commonService.commonMainObj.newPcbOrgTurnTime;
              if(this.commonService.commonMainObj.onlyPcb == false){
              this.newAssemblyQty = this.commonService.commonMainObj.newPcbQty;
                this.commonService.commonMainObj.qtyAssemblies = this.commonService.commonMainObj.newAssemblyQty;
                this.newAssemblyTurnTime = this.commonService.commonMainObj.newAssemblyTurnTime;
                this.commonService.commonMainObj.selectedAssemblyTurntime = this.commonService.commonMainObj.newAssemblyTurnTime;
                this.commonService.commonMainObj.selectedAssemblyQuantity = this.commonService.commonMainObj.newAssemblyQty
              }
              this.reQuote(this.reQuoteContentObj);
            }else{
              if(this.commonService.commonMainObj.guestEventType == 'reQuote'){
                this.commonService.alertCall('Warning!','Re-quote cannot be initiated until you sign-in/register');
                return false;
              }else if(this.commonService.commonMainObj.guestEventType == 'saveQuote'){
                this.commonService.alertCall('Warning!','Quote cannot be saved until you sign-in/register');
                return false;
              }else if(this.commonService.commonMainObj.guestEventType == 'placeOrder'){
                this.commonService.alertCall('Warning!','Order cannot be placed until you sign-in/register');
                return false;
              }
            }
          });
        },this.commonService.commonMainObj.newUser?2200:1500);
      })
    }else{
      this.guestUserFlowInitFn()
    }
  }

  guestUserFlowInitFn(){
    setTimeout(()=>{
      window.scrollTo(0, 0);
    },200);
    this.initFn();
    this.checkBomAutoUploaded = this.commonService.commonMainObj.autoUploadFileName;
    this.commonService.restrictBrowserButtons();
    if(this.commonService.commonMainObj.assemblyQuoteJson[0]){
      this.greaterBomResponse = (this.commonService.commonMainObj.assemblyQuoteJson[0].callUs).split('<br>');
    }
    setTimeout(() => {
      if(this.commonService.commonMainObj.greaterQtyResp){
        // this.assemblyYesCheck();
        this.quoteDetailList.numOfBoards = this.commonService.commonMainObj.selectedFabQuantity;
        this.quoteDetailList.pcbTurnTime = this.commonService.commonMainObj.selectedFabTurntimeVal <= 9 ? this.commonService.commonMainObj.selectedFabTurntimeVal.split('')[0] : this.commonService.commonMainObj.selectedFabTurntimeVal;
        // this.quoteDetailList.customNumOfAssemblies = this.commonService.commonMainObj.qtyAssemblies;
        // this.quoteDetailList.customaAssemblyTurnTime = this.commonService.commonMainObj.selectedFabTurntimeVal <= 9 ? this.commonService.commonMainObj.selectedFabTurntimeVal.split('')[0] : this.commonService.commonMainObj.selectedFabTurntimeVal;
      }
    }, 1000);
    // setTimeout(() => {
    //   if(this.commonService.commonMainObj.autoUploadFileName){
    //     $('#assemblyYes').trigger('click');
    //   }
    // },1500);
    
  }

  
  userSessionCheck(){
    this.commonService.loadingShow();
    let sessionData = localStorage.getItem('encData')
    this.apiService.getUserDataSession(sessionData).subscribe((resData: any)=>{
      this.commonService.loadingHide();
      this.commonService.commonMainObj.userSessionMemberId = resData.memberId;
      if(localStorage.getItem('apDtId') && localStorage.getItem('apDtId') != ''){
        if(resData && resData.status == "NO_SESSION"){
          this.commonService.commonMainObj.userData = {};
          this.commonService.commonMainObj.sessionCheck = false;
          this.commonService.commonMainObj.isGuestUser = true;
        }else if(resData && resData.status == 'SESSION_FOUND'){
          if(this.commonService.commonMainObj.email && resData.registrationEmail != this.commonService.commonMainObj.email){
            this.commonService.commonMainObj.invalidUser = true;
            this.commonService.commonMainObj.loginEmail = resData.registrationEmail
            this.commonService.commonMainObj.boardDetailsDataObj.email = resData.registrationEmail;
          }
          this.commonService.commonMainObj.userId = resData.userId
          this.commonService.commonMainObj.userData = resData;
          this.commonService.commonMainObj.sessionCheck  = true;
          this.commonService.commonMainObj.isGuestUser = false;
        }
      }
      //this.initFn();
      if(this.commonService.commonMainObj.tryToSigninOrRegister){
        setTimeout(() => {
          let signInMsgObj={
            "signIn": this.commonService.commonMainObj.invalidUser ? "Sign-in failed": this.commonService.commonMainObj.newUser? 'Registration successful':'Sign-in successful'
          };
      
          this.apiService.updateDetailsToDashboard(this.flowActivityId,signInMsgObj,'SignInRegistrationPage').subscribe((resDatas)=>{
          },err=>{
            console.log(err)
          });  
        }, 1000);
      }
    },err=>{
      if(err.status == 200){
        if(err.error.text == "NO_SESSION"){
          this.commonService.commonMainObj.sessionCheck = false;
        }else{
          this.commonService.commonMainObj.userData = {};
        }
      }
      console.log(err)
    });
  }

  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }


  initFn(){
    this.commonService.formattingCurrentDateTime();
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    let quoteInitObj={
     "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    if(this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'){
      this.apiService.updateDetailsToDashboard(this.flowActivityId,quoteInitObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas)=>{
      });
    }else{
      this.apiService.updateDetailsToDashboard(this.flowActivityId,quoteInitObj,'ConfirmQuoteRequestPage').subscribe((resDatas)=>{
        });
    }
    $('#guestSaveQuoteProcess').hide();
    this.commonService.commonMainObj.customAssemblySelected = false;
    this.quoteBOM = Object.assign({},this.commonService);
    if(this.commonService.commonMainObj.fileUploadedData.uploadedBOM && Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM).length >0 && this.commonService.commonMainObj.manuallyBomUploded == false){
      this.commonService.commonMainObj.autoUploadFileName = Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0];
      this.commonService.commonMainObj.autoUploadFileId = Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0]
    }

    if(this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'){
      this.newPcbQty = this.commonService.commonMainObj.selectedFabQuantity;
      this.newPcbTurnTime = this.commonService.commonMainObj.selectedFabTurntimeVal;
      this.newPcbOrgTurnTime = this.commonService.commonMainObj.selectedFabOrgTurntime;
      this.newAssemblyQty = this.commonService.commonMainObj.selectedAssemblyQuantity;
      this.newAssemblyTurnTime = this.commonService.commonMainObj.selectedAssemblyTurntime;
      this.apiService.getCountryList();
      this.apiService.getStateByCountry();
      this.apiService.getCityByState();
      $('#standard-pcb-quote-sec').show();
      this.commonService.commonMainObj.wqId = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.wqID;
      let total = 0;
      let total_turntime = 0;
      let id =1;
      for(let i of this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems){
        total = total + parseFloat(i.subTotal);
        this.fabTotal =total.toFixed(2);
        total_turntime += (i.quoteItemType == "COMPONENTS" ? 0 : parseInt(i.turntime));
        let partData = this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData;
        this.savedPartNum = partData.partNumber;
        this.savedPartRevision = partData.partRevision;
        this.savedSurfaceFinish = partData.surfaceFinish;
        this.savedMaterial = partData.material;
        this.commonService.commonMainObj.savedBoardDimensions = (this.commonService.commonMainObj.indBoardXDim.toString().startsWith('.') ? '0' + this.commonService.commonMainObj.indBoardXDim : this.commonService.commonMainObj.indBoardXDim) + ' x ' + (this.commonService.commonMainObj.indBoardYDim.toString().startsWith('.') ? '0' + this.commonService.commonMainObj.indBoardYDim : this.commonService.commonMainObj.indBoardYDim) + '(inches)';
        if(partData.layers > 1){
          this.savedLayer = partData.layers + ' Layers';
        }else{
          this.savedLayer = partData.layers + ' Layer';
        }
        this.savedItar = partData.itar;
        this.electricalTesting = partData.electricalTesting;
        this.testingValFromApi = parseFloat(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].electricalTestingPrice).toFixed(2);
        if(partData.electricalTesting == "No"){
          $('#electricalTestingYes').removeClass('active');
          $('#electricalTestingYes').removeClass('btn-green');
          $('#electricalTestingYes').addClass('btn-gray');
          $('#electricalTestingNo').removeClass('btn-gray');
          $('#electricalTestingNo').addClass('active');
          $('#electricalTestingNo').addClass('btn-green');
          this.electricalTestingPrice = "0.00";
        }else{
          $('#electricalTestingNo').removeClass('active');
          $('#electricalTestingNo').removeClass('btn-green');
          $('#electricalTestingNo').addClass('btn-gray');
          $('#electricalTestingYes').removeClass('btn-gray');
          $('#electricalTestingYes').addClass('active');
          $('#electricalTestingYes').addClass('btn-green');
          this.electricalTestingPrice = parseFloat(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].electricalTestingPrice).toFixed(2);
        }
        this.totalQuoteValue = total.toFixed(2);
        this.totalQuoteValueWithoutElectricTesting  = parseFloat(this.totalQuoteValue)  - parseFloat(this.testingValFromApi );
        this.totalQuoteValueWithElectricTesting = parseFloat(this.totalQuoteValue);
        this.elecTestChk = parseFloat(i.electricalTestingPrice).toFixed(2);
        this.commonService.commonMainObj.electricalTestingPriceVal  = this.elecTestChk;
        this.commonService.commonMainObj.unitPrice  = parseFloat(i.unitPrice).toFixed(2);
        this.fabSubTotal = parseFloat(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].subTotal).toFixed(2);
        this.fabTotalWithoutElectricalTesting = this.fabTotal - this.testingValFromApi;
        this.fabSubtotalWithoutElectricalTesting = this.fabSubTotal - this.testingValFromApi;
        this.fabSubTotalWithElectricalTesting = parseFloat(this.fabSubTotal) ;
        this.fabTotalWithElectricalTesting = parseFloat(this.totalQuoteValue);
        let turnTimeFromApi;
        if(i.turntime > 1){
          turnTimeFromApi = i.turntime  + ' Days';
        }else{
          turnTimeFromApi = i.turntime  + ' Day';
        }
        $('#quote-display-tbody').append(
          '<tr><td align="center" valign="top"><strong><font color="#1e1f21">'+i.quoteItemType+'</font></strong><br><br>'+i.webQuoteItemNo+'<br></td>' +
          '<td align="center" valign="top">'+i.partNo+' / '+i.partRevNo+'</td>' +
          '<td align="center" valign="top">'+(i.quoteItemType == "PCB" ? i.quantity+' Boards': i.quantity+' Assemblies')+'</td>' +
          '<td align="center" valign="top">'+(i.quoteItemType == "COMPONENTS" ? '-': turnTimeFromApi)+'</td>' +
          '<td align="center" valign="top">'+(i.quoteItemType == "COMPONENTS" ? '-':'$'+parseFloat(i.unitPrice).toFixed(2))+'</td>' +
          '<td align="center" valign="top">$'+parseFloat(i.boardPrice).toFixed(2)+'</td>' +
          '<td align="center" valign="top">'+(i.quoteItemType == "COMPONENTS" ? '-': '$0.00<br><div class="nreFreeText tooltipCustom" tooltip-text="Unlike our competitors, we offer free NRE with this service.">FREE!</div>')+'</td>' +
          '<td align="center" valign="top" nowrap=""><input readonly="" size="10" style="border:none;text-align:center;outline:none;" type="text" name="txtElecTest0" id="txtElecTest_'+id+'" value="'+(i.quoteItemType == "COMPONENTS" ? '-': (i.quoteItemType == "PCB" ? '$'+  this.electricalTestingPrice: '-'))+'">'+'</td>' +
          '<td align="center" valign="top" id="quote-display-misc-td">$'+i.miscOrOther+'</td>' +
          '<td align="center" valign="top" id="quote-display-subtotal-td"><input readonly="" size="10" style="border:none;outline:none;text-align:center;" type="text" name="subTotal0" id="subTotal_'+id+'" value="$'+parseFloat(i.subTotal).toFixed(2)+'"></td></tr>'
        );
        id++;
      }
      $('#quote-display-tbody').append(
        '<tr><td align="left" valign="middle" colspan="2" style="padding:10px;border-right:0px;display:none;"></td>'+
        '<td align="right" valign="middle" colspan="3" style="padding:10px;border-right:0px"><strong>Total Turn Time</strong></td>'+
        '<td align="center" valign="middle" style="padding:10px;border-right:none;" id="quote-display-total-turntime-td">'+total_turntime+' Days</td>'+
        '<td align="right" valign="top" colspan="5"><strong>TOTAL&nbsp;&nbsp;</strong><br>'+
        '<span class="instant-quote-form-text-2" style="font-size: 12px;">(not including Shipping and any applicable taxes)</span>&nbsp;&nbsp;&nbsp;</td>'+
        '<td align="center" valign="top"><strong><input readonly="" size="10" style="font-size:16px;font-weight:bold;border:none;outline:none;text-align:center;" type="text" name="txtLotTotal" id="txtLotTotal" value="$'+total.toFixed(2)+'"></strong></td></tr>'
      )
      if(this.savedLayer.split(' ')[0] > 6){
        $('#electricalTestingNo').prop("disabled",true);
        $('#electricalTestingYes').prop("disabled",true);
        $('#electricalTestingNo').css('cursor','no-drop');
        if($('#electricalTestingNo').hasClass('active')){
          $('#electricalTestingNo').removeClass('active');
          $('#electricalTestingNo').removeClass('btn-green');
          $('#electricalTestingNo').addClass('btn-gray');
          $('#electricalTestingYes').removeClass('btn-gray');
          $('#electricalTestingYes').removeClass('active');
          $('#electricalTestingYes').addClass('btn-green');
        }
      }else{
        $('#electricalTestingNo').prop("disabled",false);
        $('#electricalTestingNo').css('cursor','pointer');
      }
    }else{
      $('#standard-pcb-quote-sec').hide();
      this.quoteDetailList.numOfBoards = this.commonService.commonMainObj.maxBoardQuantity;
      this.quoteDetailList.pcbTurnTime = this.newPcbOrgTurnTime ? this.quoteDetailList.pcbTurnTime : this.commonService.commonMainObj.selectedFabTurntimeVal ? this.commonService.commonMainObj.selectedFabTurntimeVal <= 9 ? this.commonService.commonMainObj.selectedFabTurntimeVal.split('')[0] : this.commonService.commonMainObj.selectedFabTurntimeVal:5;
      this.savedPartNum = this.commonService.commonMainObj.partNumber;
      this.savedPartRevision = this.commonService.commonMainObj.partRevision;
      this.savedSurfaceFinish = this.commonService.commonMainObj.surfaceFinish;
      this.savedMaterial = this.commonService.commonMainObj.material;
      this.commonService.commonMainObj.savedBoardDimensions = (this.commonService.commonMainObj.indBoardXDim.toString().startsWith('.') ? '0' + this.commonService.commonMainObj.indBoardXDim : this.commonService.commonMainObj.indBoardXDim) + ' x ' + (this.commonService.commonMainObj.indBoardYDim.toString().startsWith('.') ? '0' + this.commonService.commonMainObj.indBoardYDim : this.commonService.commonMainObj.indBoardYDim) + '(inches)';
      if(this.commonService.commonMainObj.selectedLayerVal >  1){
        this.savedLayer = this.commonService.commonMainObj.selectedLayerVal + ' Layers';
      }else{
        this.savedLayer = this.commonService.commonMainObj.selectedLayerVal + ' Layer';
      }
      
      this.savedItar = this.commonService.commonMainObj.itar;
      let boardQty = parseInt(this.commonService.commonMainObj.maxBoardQuantity)
      this.changedNoOfBoards = boardQty
      this.commonService.commonMainObj.customQtyAssemblies = this.commonService.commonMainObj.maxBoardQuantity;
      this.quoteDetailList.customNumOfAssemblies = this.newAssemblyQty?this.newAssemblyQty:this.commonService.commonMainObj.maxBoardQuantity;
      this.quoteDetailList.customaAssemblyTurnTime = this.newPcbOrgTurnTime?this.quoteDetailList.customaAssemblyTurnTime:5;
    }
    setTimeout(()=>{
      window.scrollTo(0, 0);
    },1000)
  }

  placeOrder(){
    this.commonService.sessionPortalLoad();
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
      this.commonService.loadingShow();
      setTimeout(()=>{
        this.commonService.loadingHide();
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.commonService.commonMainObj.electricalTesting = $('#electricalTestingYes').hasClass('active')?"Yes":"No";
            let placeOrderClickObjj={
              "placeOrderInitiated" : 'Yes'
            }
            this.apiService.updateDetailsToDashboard(this.flowActivityId,placeOrderClickObjj,'ConfirmQuoteRequestPage').subscribe((resDatas)=>{
              });
            if(this.commonService.commonMainObj.onlyPcb == false){
              this.router.navigateByUrl('/aditinalComponentDetails');
            }else{
              this.router.navigateByUrl('/orderDetails');
            }
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      },2000);
    }
  }

  assemblyYesCheck(){
    $('#assemblyNo').removeClass('btn-green');
    $('#assemblyNo').addClass('btn-gray');
    $('#assemblyYes').addClass('btn-green');
    $('#assemblyYes').removeClass('btn-gray');
    $('#assemblyNo').removeClass('active');
    $('#assemblyYes').addClass('active');
    this.commonService.commonMainObj.customAssemblySelected = true;
    this.bomUploadSec = true;
  }
  switchOfButtons(event:any, content:any){
    let currentElement = event.target.id;
    if(currentElement == "electricalTestingNo"){
      $('#electricalTestingYes').removeClass('btn-green');
      $('#electricalTestingYes').addClass('btn-gray');
      $('#electricalTestingNo').addClass('btn-green');
      $('#electricalTestingNo').removeClass('btn-gray');
      $('#electricalTestingYes').removeClass('active');
      $('#electricalTestingNo').addClass('active');
      this.fabSubtotalWithoutElectricalTesting = parseFloat(this.fabSubTotal) - parseFloat(this.testingValFromApi);
      this.totalQuoteValueWithoutElectricTesting = parseFloat(this.totalQuoteValue) - parseFloat(this.testingValFromApi);
      $('#txtElecTest_1').val('$0.00');
      $('#subTotal_1').val('$'+this.fabSubtotalWithoutElectricalTesting.toFixed(2)); 
      $('#txtLotTotal').val('$'+this.totalQuoteValueWithoutElectricTesting.toFixed(2));
    }else if(currentElement == "electricalTestingYes"){
      $('#electricalTestingNo').removeClass('btn-green');
      $('#electricalTestingNo').addClass('btn-gray');
      $('#electricalTestingYes').addClass('btn-green');
      $('#electricalTestingYes').removeClass('btn-gray');
      $('#electricalTestingNo').removeClass('active');
      $('#electricalTestingYes').addClass('active');
      this.fabSubTotalWithElectricalTesting = parseFloat(this.fabSubTotal) ;
      this.totalQuoteValueWithElectricTesting = parseFloat(this.totalQuoteValue);
      $('#txtElecTest_1').val('$'+this.testingValFromApi);
      $('#subTotal_1').val('$'+this.fabSubTotalWithElectricalTesting.toFixed(2));
      $('#txtLotTotal').val('$'+this.totalQuoteValueWithElectricTesting.toFixed(2));

    }else if(currentElement == "assemblyNo"){
      $('#assemblyYes').removeClass('btn-green');
      $('#assemblyYes').addClass('btn-gray');
      $('#assemblyNo').addClass('btn-green');
      $('#assemblyNo').removeClass('btn-gray');
      $('#assemblyYes').removeClass('active');
      $('#assemblyNo').addClass('active');
      this.commonService.commonMainObj.customAssemblySelected = false;
      this.curentFileUploadedName = '';
      this.bomUploadSec = false;
    }else if(currentElement == "assemblyYes"){
      setTimeout(()=>{
        if(this.commonService.commonMainObj.assemblySides == '2 side'){
          $('#numberOfSidesTwo').trigger('click');
        }else{
          $('#numberOfSidesOne').trigger('click');
        }
        if(this.commonService.commonMainObj.leadFreeProcessing == 'Yes'){
          $('#leadFreeYes').trigger('click');
        }else{
          $('#leadFreeNo').trigger('click');
        }
        if(this.commonService.commonMainObj.viaInPadData == 'Yes'){
          $('#viaInPadsYes').trigger('click');
        }else{
          $('#viaInPadsNo').trigger('click');
        }
      },300);
      if(Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length > 0){
        this.disableAssemblyErrorProceed = true;
        this.checkAssemblyErrorModal(content);
      }else{
        this.assemblyYesCheck();
      }
    }
    
  }

  wantReQuote(event:any){
    var currentElement = event;
    if(currentElement == 'reQuoteYes'){
      $('#reQuoteYes').trigger('click');
      $('#reQuoteNo').removeClass('btn-green');
      $('#reQuoteNo').addClass('btn-gray');
      $('#reQuoteYes').addClass('btn-green');
      $('#reQuoteYes').removeClass('btn-gray');
      $('#reQuoteNo').removeClass('active');
      $('#reQuoteYes').addClass('active');
      this.commonService.commonMainObj.reQuoteEnable = true;
    }else{
      $('#reQuoteNo').trigger('click');
      $('#reQuoteYes').removeClass('btn-green');
      $('#reQuoteYes').addClass('btn-gray');
      $('#reQuoteNo').addClass('btn-green');
      $('#reQuoteNo').removeClass('btn-gray');
      $('#reQuoteYes').removeClass('active');
      $('#reQuoteNo').addClass('active');
      this.commonService.commonMainObj.reQuoteEnable = false;
    }
  }

  uploadFiles(logs: any){
    if(this.commonService.commonMainObj.autoUploadFileName){
      this.autoBomReplaceAlert(logs);
    }else{
      $('#fileInputOther').trigger('click');

      this.fileBrowseHandler(logs);
    }
  }
  autoBomReplaceAlert(logs: any){
    this.commonService.bomConfirmAlert('The existing BOM in the initial files will be replaced with the new BOM. Are you sure you want to proceed with uploading a different BOM?').then((result:any) => {
      if (result.isConfirmed) {
        $('#fileInputOther').trigger('click');
        this.checkBomReuploaded = true;
        this.fileBrowseHandler(logs);
      } else if (result.isDismissed) {
        return false;
      }
    })
  }
  fileBrowseHandler(logs: any): void {
    const inputElement = logs.target;
    if (inputElement.files && inputElement.files.length > 0) {
      this.curentFileUploadedName = inputElement.files[0].name;
      let fileExtension = this.curentFileUploadedName.split('.').pop()?.toLowerCase();
      let allowedFileExtensions  = ['xls','xlsx'];
      if (fileExtension && allowedFileExtensions.includes(fileExtension)) {
        this.checkBomAdded = this.checkBomAutoUploaded != '' ? false:true;
        this.bomChanged = (this.checkBomAdded == false && this.commonService.commonMainObj.uploadedFile != '') ? true:false;
        this.commonService.commonMainObj.uploadedFile = inputElement.files[0];
        this.commonService.commonMainObj.uploadedFileFullPath = inputElement.value;
        this.commonService.commonMainObj.autoUploadFileName = '';
        this.IsAllowedFileExtension = true;
        this.commonService.commonMainObj.uploadedFileFullPath = inputElement.value;
        this.commonService.commonMainObj.autoUploadFileName = '';
        this.curentFileUploadedName = this.commonService.commonMainObj.uploadedFile.name
        this.commonService.commonMainObj.manuallyBomUploded = true;
        this.commonService.commonMainObj.customQuoteManualBomUpload = true;

        //Below code is for manually uploded file converting into blod data to attach uploded file to zip
        const file = inputElement.files[0];
        const reader = new FileReader();
        let convertedFile :any = [];
        reader.readAsDataURL(file);
        reader.onload = () => {
          convertedFile = reader.result;
        };
        setTimeout(() => {
          if(convertedFile){
            this.commonService.commonMainObj.bomToBloobFile = convertedFile.toString().split('base64,')[1]
          }
        }, 100);
      }else{
        this.IsAllowedFileExtension = false;
        this.curentFileUploadedName = this.commonService.commonMainObj.uploadedFile.name? this.commonService.commonMainObj.uploadedFile.name:'';
        // this.curentFileUploadedName='';
        this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
        return;
      }
    }
  }
  changeAssemblyTurnTime(input:any,event:any){
    let uInput = event.target.value;
    // Remove any non-numeric characters
    event.target.value = uInput.replace(/[^0-9]/g, '');
    let currentNumOfBoards = event.target.value;
    this.changedNoOfBoards = currentNumOfBoards
    //OFP-980 commenting below line
    //this.quoteDetailList.customNumOfAssemblies = this.qtyIndvBoardsArray[0];
    this.quoteDetailList.customNumOfAssemblies = currentNumOfBoards;
     this.commonService.commonMainObj.customQtyAssemblies = this.quoteDetailList.customNumOfAssemblies;
  }

  openListOfSpecification(content:any){
    let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  goToSaveQuote(){
    this.router.navigateByUrl('/quoteStatus');
  }

  close() {
    this.modalService.dismissAll();
  }


// orderPlaceGuest(){
//   this.commonService.commonMainObj.electricalTesting = $('#electricalTestingYes').hasClass('active')?"Yes":"No",
//   localStorage.setItem('commonDataObj','')
//   localStorage.setItem('commonDataObj',JSON.stringify(this.commonService.commonMainObj));
//   localStorage.setItem('apiSerDataObj','')
//   localStorage.setItem('apiSerDataObj',JSON.stringify(this.apiService.apiMainObj));
//   let redirectUrl = 'https://staging.protoexpress.com/customer-portal/login/?src=https://oneflowqa.app.protoexpress.com/orderDetails?fileId='+ localStorage.getItem('fileId');
//   window.open(redirectUrl,"_self");
//   // this.router.navigateByUrl('/orderDetails');
// }
backToBoardDetails(){
  let backToBoardDetailsObj={
    "returnedToBoardDetailsPage": 'Yes',
  }
  this.commonService.commonMainObj.backToBoardDetails = true;
  this.commonService.commonMainObj.selectedFabTurntime = '';
  this.apiService.updateDetailsToDashboard(this.flowActivityId,backToBoardDetailsObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas:any)=>{
    // console.log("updateDetailsToDashboard",resDatails);
    this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId; 
    })
  this.router.navigateByUrl('/boardDetails');  
}

guestOrderPlace(evtType:any){
    this.commonService.commonMainObj.guestEventType = evtType;
  let placeOrderClickObj={
    "placeOrderInitiated" : 'Yes'
  }
  this.commonService.commonMainObj.tryToSigninOrRegister = true;
  if(evtType == 'placeOrder'){
    this.apiService.updateDetailsToDashboard(this.flowActivityId,placeOrderClickObj,'ConfirmQuoteRequestPage').subscribe((resDatas)=>{
      // console.log("updateDetailsToDashboard",resDatails);
    });
  }
  if(evtType != 'saveQuote'){
    this.commonService.commonMainObj.electricalTesting = $('#electricalTestingYes').hasClass('active')?"Yes":"No";
  }
  // localStorage.setItem('commonDataObj','')
  // localStorage.setItem('commonDataObj',JSON.stringify(this.commonService.commonMainObj));
  // localStorage.setItem('apiSerDataObj','')
  // localStorage.setItem('apiSerDataObj',JSON.stringify(this.apiService.apiMainObj));

  this.apiService.saveAppData().subscribe((appDataObj) =>{
    localStorage.setItem('apDtId','')
    localStorage.setItem('apDtId',appDataObj.id);
    this.guestDataCheckcondition(evtType);
  }, error =>{
    console.log('Bom file saving Error2', error);
  })
  // this.router.navigateByUrl('/orderDetails');
}

  guestDataCheckcondition(evtType:any){
    if(evtType == 'placeOrder' && this.commonService.commonMainObj.onlyPcb == true){
      if( this.commonService.commonMainObj.newUser == false){
        let redirectUrl = this.apiService.portalUrl + 'customer-portal/login/?src='+this.apiService.stagOneflowUrl+'/orderDetails?fileId='+ localStorage.getItem('fileId');
        this.emailConfirmAlert('You need to sign-in to place an order. You will be redirected to login page now, please enter the email id provided earlier in this flow, else you will not be able to place the order successfully.',redirectUrl);
        this.commonService.commonMainObj.tryToRegister = false;
      }else{
        let redirectUrl = this.apiService.portalUrl + 'customer-portal/signup/?src='+this.apiService.stagOneflowUrl+'/orderDetails?fileId='+ localStorage.getItem('fileId')+'&wqID='+this.commonService.commonMainObj.wqId+'&email='+this.commonService.commonMainObj.email
        this.emailConfirmAlert('',redirectUrl);
        this.commonService.commonMainObj.tryToRegister = true;
      }
    }else if(evtType == 'placeOrder' && this.commonService.commonMainObj.onlyPcb == false){
      if( this.commonService.commonMainObj.newUser == false){
        let redirectUrl = this.apiService.portalUrl + 'customer-portal/login/?src='+this.apiService.stagOneflowUrl+'/aditinalComponentDetails?fileId='+ localStorage.getItem('fileId');
        this.emailConfirmAlert('You need to sign-in to place an order. You will be redirected to login page now, please enter the email id provided earlier in this flow, else you will not be able to place the order successfully.',redirectUrl);
        this.commonService.commonMainObj.tryToRegister = false;
      }else{
        let redirectUrl = this.apiService.portalUrl + 'customer-portal/signup/?src='+this.apiService.stagOneflowUrl+'/aditinalComponentDetails?fileId='+ localStorage.getItem('fileId')+'&wqID='+this.commonService.commonMainObj.wqId+'&email='+this.commonService.commonMainObj.email
        this.emailConfirmAlert('',redirectUrl);
        this.commonService.commonMainObj.tryToRegister = true;
      } 
    }else{
      if( this.commonService.commonMainObj.newUser == false){
        this.commonService.commonMainObj.tryToRegister = false;
        let redirectUrl = this.apiService.portalUrl + 'customer-portal/login/?src='+this.apiService.stagOneflowUrl+'/quoteStatus?fileId='+ localStorage.getItem('fileId');
        if(this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'){
          this.emailConfirmAlert('You need to sign-in to save the quote. You will be redirected to login page now, please enter the email id provided earlier in this flow, else you will not be able to save the quote successfully.',redirectUrl);
        }else{
          this.emailConfirmAlert('',redirectUrl);
        }
      }else{
        this.commonService.commonMainObj.tryToRegister = true;
        let redirectUrl = this.apiService.portalUrl + 'customer-portal/signup/?src='+this.apiService.stagOneflowUrl+'/quoteStatus?fileId='+ localStorage.getItem('fileId')+'&wqID='+this.commonService.commonMainObj.wqId+'&email='+this.commonService.commonMainObj.email
        this.emailConfirmAlert('',redirectUrl);
      }
    }
  }

  emailConfirmAlert(text:any,redirectUrl:any){
    if(text){
      Swal.fire({
        title: 'Info',
        text:text,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        allowEscapeKey : false,
        backdrop:false
      }).then((result) => {
        if (result['isConfirmed']){
          window.open(redirectUrl,"_self");
        }else{
          localStorage.setItem('commonDataObj','');
          localStorage.setItem('apiSerDataObj','');
          localStorage.setItem('apDtId','');
        }
      })
    }else{
      window.open(redirectUrl,"_self");
    }
  }

attachUploadedBomToZip(evtType:any){
  let objData = {
    "file1":{
      "file": this.commonService.commonMainObj.bomToBloobFile,
      "fileName":this.commonService.commonMainObj.uploadedFile.name,
      "errorCode":"FV_BM_E00",//this error code is for only uploded BOM attach
    }
  }
  let dataFile = JSON.stringify(objData);
  let formData = new FormData();
  formData.append('data',dataFile);
  formData.append('s3ZipFileName', this.commonService.commonMainObj.s3FileName);
  formData.append('reValidate', "True");
  this.apiService.reValidateMissingFiles(formData).subscribe((data: any)=>{
    this.commonService.commonMainObj.s3FileName = data.s3_file;
    this.saveQuote(evtType);
    if(Object.keys(data['assemblyErrors']).length == 0){
      console.log("No error found");
    }
    if(Object.keys(data['assemblyErrors']).length > 0){
      console.log("error found");
    }
  });
}

  guestQuoteSave(evtType:any){
    this.commonService.commonMainObj.guestEventType = evtType;
    this.commonService.sessionPortalLoad();
    if(evtType == 'saveQuote'){
      if(this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'){
        let customQuoteObj={
          "quoteRequestPlaced":'Yes',
        }
        this.apiService.updateDetailsToDashboard(this.flowActivityId,customQuoteObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas)=>{
        });
      }else{
        let saveQuoteDataObj={
          "quoteSaved":'Yes',
        }
        this.apiService.updateDetailsToDashboard(this.flowActivityId,saveQuoteDataObj,'ConfirmQuoteRequestPage').subscribe((resDatas)=>{
        });
      }
    }
    let bomFile = this.commonService.commonMainObj.uploadedFile;
    if(this.bomUploadSec == true){
      if(!this.commonService.commonMainObj.fileUploadedData.uploadedBOM && !this.commonService.commonMainObj.uploadedFile){
        this.commonService.alertCall('Alert!!','Please upload a BOM file');
        return;
      }
      if (!this.IsAllowedFileExtension && !this.commonService.commonMainObj.fileUploadedData.uploadedBOM && !this.commonService.commonMainObj.uploadedFile){
        this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
        return;
      }
      if(this.commonService.commonMainObj.fileUploadedData.uploadedBOM && this.commonService.commonMainObj.autoUploadFileName){
        this.commonService.loadingShow();
        this.apiService.getAutoUploadBOMFile(Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0],"xlFileData").subscribe((data: any)=>{
          this.commonService.commonMainObj.uploadedFile = data;
          this.commonService.commonMainObj.uploadedFile['name'] = Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0];
          this.bomAutoMapData(data.body,'');
        }, (error: any)=>{
          this.commonService.loadingHide();
        });
      }else{
        this.commonService.loadingShow();
        this.bomAutoMapData(bomFile,'');
      }
    }

    if(this.commonService.commonMainObj.customAssemblySelected){
      if(this.quoteDetailList.customNumOfAssemblies && this.quoteDetailList.customNumOfAssemblies <= this.changedNoOfBoards){
        if(this.commonService.commonMainObj.manuallyBomUploded == true && this.commonService.commonMainObj.customQuoteManualBomUpload){
          this.attachUploadedBomToZip(evtType);
        }else{
          this.saveQuote(evtType);
        }
      }else{
        let msg = 'Number of Assemblies should be less than or equal to Number of PCB Boards';
        let msg2 = 'Number of Assemblies is required';
        this.commonService.showtoast(this.quoteDetailList.customNumOfAssemblies?msg:msg2,'warning');
        return false;
      }
    }else{
      if(this.commonService.commonMainObj.manuallyBomUploded == true && this.commonService.commonMainObj.customQuoteManualBomUpload){
        //this.bomAutoMapData(bomFile,'');
        this.attachUploadedBomToZip(evtType);
      }else{
        this.saveQuote(evtType);
      }
    }
  }

  saveQuote(evtType:any){
    this.commonService.sessionPortalLoad();
    if(this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'){
      if(this.commonService.commonMainObj.isGuestUser == true){
        this.guestOrderPlace(evtType);
      }else{
        this.commonService.loadingShow();
        this.commonService.sessionPortalLoad();
        setTimeout(() => {
          this.commonService.loadingHide();
          this.commonService.sessionPortalLoad();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.goToSaveQuote();
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
        }, 1500);
      }
    }else{
      if(this.quoteDetailList.numOfBoards == ''){
      this.commonService.alertCall('Alert!!','Please enter number of boards.');
        return;
      }
      if(this.commonService.commonMainObj.customAssemblySelected == true){
        if(!this.commonService.commonMainObj.fileUploadedData.uploadedBOM && !this.commonService.commonMainObj.uploadedFile ){
          this.commonService.alertCall('Alert!!','Please upload a BOM file');
          return;
        }
        if ((this.IsAllowedFileExtension == false) && (this.commonService.commonMainObj.fileUploadedData.uploadedBOM && this.commonService.commonMainObj.uploadedFile)){
          this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
          return;
        }

      }
      this.commonService.commonMainObj.boardDetailsDataObj.noOfBoards = this.quoteDetailList.numOfBoards;
      this.commonService.commonMainObj.boardDetailsDataObj.pcbTurntime = this.quoteDetailList.pcbTurnTime;
      this.commonService.commonMainObj.boardDetailsDataObj.noOfBareBoard = '';
      this.commonService.commonMainObj.boardDetailsDataObj.noOfAssemblyBoard = this.quoteDetailList.customNumOfAssemblies && this.commonService.commonMainObj.customAssemblySelected == true ?this.quoteDetailList.customNumOfAssemblies:'' ;
      this.commonService.commonMainObj.boardDetailsDataObj.assemblyTurnTime = this.quoteDetailList.customaAssemblyTurnTime && this.commonService.commonMainObj.customAssemblySelected == true ?this.quoteDetailList.customaAssemblyTurnTime:'' ;
      this.commonService.commonMainObj.customAssemblySides = $('#numberOfSidesOne').hasClass('active') ? '1 side': '2 sides';
      this.commonService.commonMainObj.customLeadFreeProcessing = $('#leadFreeYes').hasClass('active') ? 'Yes': 'No';
      this.commonService.commonMainObj.customViaInPadData = $('#viaInPadsYes').hasClass('active') ? 'Yes': 'No';
      if(this.commonService.commonMainObj.isGuestUser == true){
        this.guestOrderPlace(evtType);
      }else{
        this.commonService.loadingShow();
        this.commonService.sessionPortalLoad();
        setTimeout(() => {
          this.commonService.sessionPortalLoad();
          this.commonService.loadingHide();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.goToSaveQuote();
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
        }, 1500);
      }
    }
  }

  assemblyErrorsCheck(){
    if(Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length > 0){
      this.commonService.commonMainObj.uploadedFilesData['fileAsmblyErrors'] = []
      for(let errIndx in this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']){
        this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'][errIndx]['errorCode'] = errIndx;
        this.commonService.commonMainObj.uploadedFilesData['fileAsmblyErrors'].push(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'][errIndx]);
      }
    }
  }
  checkAssemblyErrorModal(content:any){
    this.assemblyErrorsCheck();
    let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "fileErrors-assembly"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.missingFiles = [];
      this.missingListFiles = [];
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.missingFiles = [];
      this.missingListFiles = [];
    });
    this.disableAssemblyErrorProceed = true;
  }
  
  missingFilesHandel(event:any, Id:any){
    let uploadedFile = event.target.files[0];
    let uploadedFileName = event.target.files[0].name;
    let base64File : any;
    let base64Data:any;
    this.missingFiles[Id] = [];
    if(uploadedFileName.split(".").pop() == "zip" || uploadedFileName.split(".").pop() == "rar"){
      $('#'+Id+'_error').text("Zipped files are not allowed, please upload the missing individual file");
      return false;
    }else{
      $('#'+Id+'_error').text('');
      $('#'+Id+'_name').text(uploadedFileName);
      $('#'+Id+'_delete').show();
      $('#'+Id).parent().hide();
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(uploadedFile);
      reader.onload = () => {
        base64File = reader.result;
      };
      setTimeout(() => {
        if(base64File){
          base64Data = base64File.toString().split('base64,')[1]
        }
      }, 100);
      this.missingFiles[Id]={}
      this.missingFiles[Id]['errCode'] = Id;
      this.missingFiles[Id]['fileName'] = uploadedFileName;
      setTimeout(() => {
        this.missingFiles[Id]['file'] = base64Data;
      }, 200);
    }
    setTimeout(() => {
      this.missingListFiles.push(this.missingFiles[Id]);
      if(Object.keys(this.missingFiles).length == Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length){
        this.disableAssemblyErrorProceed = false;
      }
    }, 500);
    
  }
  deleteFile(Id:any){
    $('#'+Id+'_name').text('');
    $('#'+Id+'_delete').hide();
    delete this.missingFiles[Id];
    $('#'+Id).parent().show();
    $('#'+Id).val('');
    for(let i = 0; i<this.missingListFiles.length ; i++){
      if(this.missingListFiles[i].errCode == Id){
        this.missingListFiles.splice(i, 1);
      }
    }
    if(Object.keys(this.missingFiles).length == Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length){
      this.disableAssemblyErrorProceed = false;
    }else{
      this.disableAssemblyErrorProceed = true;
    }
    
  }
  reValidate(){
    let dataObj:any = {};
    for(let i=0; i< this.missingListFiles.length; i++){
      let fileCount = Number(i)+1;
      dataObj['file'+fileCount] = {
        'file':this.missingListFiles[i].file,
        'fileName':this.missingListFiles[i].fileName,
        'errorCode': this.missingListFiles[i].errCode
      }
    }
    let dataFile = JSON.stringify(dataObj);
    let formData = new FormData();
    formData.append('data',dataFile);
    formData.append('s3ZipFileName', this.commonService.commonMainObj.s3FileName);
    formData.append('reValidate', "True");
    // console.log("formdata",formData );
    this.apiService.reValidateMissingFiles(formData).subscribe((data: any)=>{
      this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'] = [];
      this.commonService.commonMainObj.uploadedFilesData['fileAsmblyErrors'] = [];
      this.commonService.commonMainObj.s3FileName = data.s3_file;
      if(Object.keys(data['assemblyErrors']).length == 0){
        this.assemblyYesCheck();
        this.close();
      }
      if(Object.keys(data['assemblyErrors']).length > 0){
        this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'] = data['assemblyErrors'];
        this.assemblyErrorsCheck();
        this.disableAssemblyErrorProceed = true;
      }
      if((!data['assemblyErrors'].hasOwnProperty("FV_BM_E01") || !data['assemblyErrors'].hasOwnProperty("FV_BM_E00"))  && (this.missingFiles.hasOwnProperty("FV_BM_E01") || this.missingFiles.hasOwnProperty("FV_BM_E00"))){
        this.commonService.commonMainObj.autoUploadFileName = Object.values(data.uploadedBOM)[0];
        this.commonService.commonMainObj.fileUploadedData.uploadedBOM = data.uploadedBOM;
      }
    });
  }

  uploadNewFiles(){
    this.commonService.sessionPortalLoad();
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.loadingShow();
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          this.commonService.loadingHide();
          if(data.status == 1){
            this.commonService.goToFileUploadPage('otherPageReUpload','ConfirmQuoteRequestPage');
          }
        },error =>{
          console.log('Error in checking user session', error);
        })
      },2000);
    }else{
      this.commonService.goToFileUploadPage('otherPageReUpload','ConfirmQuoteRequestPage');
    }
  }

  backToComponentProcurement(){
    this.commonService.commonMainObj.backToCppFromQuotePage = true;
    this.commonService.commonMainObj.backToCPPPage = false;
    let backToCppObj ={
      "returnedToCPPage":"Yes"
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,backToCppObj,'ConfirmQuoteRequestPage').subscribe((resDatas:any)=>{
      // this.commonService.commonMainObj.backToPrevPageActivityId = resDatas.activityId;
    },err=>{
      console.log(err)
      });
    setTimeout(() => {
      this.router.navigateByUrl('/componentProcurement');
     }, 1000);  
  }

  switchOfAssmButtons(event:any){
    let currentElement = event.target.id;
    let currentElementValue = $('#'+currentElement).val();
    $('#'+currentElement).siblings().removeClass('btn-green');
    $('#'+currentElement).siblings().addClass('btn-gray');
    $('#'+currentElement).addClass('btn-green');
    $('#'+currentElement).removeClass('btn-gray');
    $('#'+currentElement).siblings().removeClass('active');
    $('#'+currentElement).addClass('active');
  }

  bomProceed(content:any){
    if(this.quoteDetailList.customNumOfAssemblies > this.quoteDetailList.numOfBoards){
      this.commonService.showtoast('Number of assemblies should be less than or equal to Number of boards.','warning');
      return false;
    }
    let bomFile = this.commonService.commonMainObj.uploadedFile;
    this.commonService.commonMainObj.bomFileData = bomFile;
    // if(this.commonService.commonMainObj.greaterQtyResp){
    //   this.commonService.commonMainObj.assemblySides = $('#numberOfSidesOne').hasClass('active') ? '1 side': '2 sides';
    //   this.commonService.commonMainObj.leadFreeProcessing = $('#leadFreeYes').hasClass('active') ? 'Yes': 'No';
    //   this.commonService.commonMainObj.viaInPadData = $('#viaInPadsYes').hasClass('active') ? 'Yes': 'No';
    // }
    this.commonService.commonMainObj.customAssemblySides = $('#numberOfSidesOne').hasClass('active') ? '1 side': '2 sides';
    this.commonService.commonMainObj.customLeadFreeProcessing = $('#leadFreeYes').hasClass('active') ? 'Yes': 'No';
    this.commonService.commonMainObj.customViaInPadData = $('#viaInPadsYes').hasClass('active') ? 'Yes': 'No';
    this.commonService.commonMainObj.customQtyOfAssemblies = this.quoteDetailList.customNumOfAssemblies
    this.commonService.commonMainObj.boardDetailsDataObj.noOfBoards = this.quoteDetailList.numOfBoards;
    this.commonService.commonMainObj.boardDetailsDataObj.pcbTurntime = this.quoteDetailList.pcbTurnTime;
    this.commonService.commonMainObj.boardDetailsDataObj.noOfBareBoard = '';
    this.commonService.commonMainObj.boardDetailsDataObj.noOfAssemblyBoard = this.quoteDetailList.customNumOfAssemblies && this.commonService.commonMainObj.customAssemblySelected == true ?this.quoteDetailList.customNumOfAssemblies:'' ;
    this.commonService.commonMainObj.boardDetailsDataObj.assemblyTurnTime = this.quoteDetailList.customaAssemblyTurnTime && this.commonService.commonMainObj.customAssemblySelected == true ?this.quoteDetailList.customaAssemblyTurnTime:'' ;
    if(this.bomUploadSec == true){
      if(!this.commonService.commonMainObj.fileUploadedData.uploadedBOM && !this.commonService.commonMainObj.uploadedFile){
        this.commonService.alertCall('Alert!!','Please upload a BOM file');
        return;
      }
      if (!this.IsAllowedFileExtension && !this.commonService.commonMainObj.fileUploadedData.uploadedBOM && !this.commonService.commonMainObj.uploadedFile){
        this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
        return;
      }
      if(!this.commonService.commonMainObj.manuallyBomUploded && Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0].indexOf('csv')>=0){
        this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
        return;
      }
      //  let requestToCustomObj={
      //   "assemblyAdded": this.commonService.commonMainObj.customAssemblySelected ? 'Yes' : '',
      //   "BomName":{
      //     "fromDesignFile":this.checkBomAutoUploaded,
      //     "added": this.checkBomAdded  == true? this.commonService.commonMainObj.uploadedFile?.name :'',
      //     "changed":this.checkBomAdded == false? this.commonService.commonMainObj.uploadedFile?.name : ''
      //   }
      // }
      // this.apiService.updateDetailsToDashboard(this.commonService.commonMainObj.fileId,requestToCustomObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas)=>{
      //   });

      if((this.commonService.commonMainObj.greaterQtyResp && !this.commonService.commonMainObj.customQuoteManualBomUpload) || (this.commonService.commonMainObj.reQuoteCheck == true && !this.commonService.commonMainObj.customQuoteManualBomUpload)){
        this.bomProcessContinueToCustomCpp();
        //this.router.navigateByUrl('/customQuoteComponentProcurement');
      }else{
        if(this.commonService.commonMainObj.fileUploadedData.uploadedBOM && this.commonService.commonMainObj.autoUploadFileName){
          this.commonService.loadingShow();
          this.apiService.getAutoUploadBOMFile(Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0],"xlFileData").subscribe((data: any)=>{
            this.commonService.commonMainObj.uploadedFile = data;
            this.commonService.commonMainObj.uploadedFile['name'] = Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0];
            this.bomAutoMapData(data.body,content);
          }, (error: any)=>{
            this.commonService.loadingHide();
          });
        }else{
          this.commonService.loadingShow();
          this.bomAutoMapData(bomFile,content);
        }
      }
    }
  }

  bomProcessContinueToCustomCpp(){
    //call bom pricing API
    var finalBomLineItems = [];
    this.commonService.commonMainObj.bomLineItemsSavedForCustomCpp = this.commonService.commonMainObj.uploadedBomDataItems;
    for(var bomcheck in this.commonService.commonMainObj.uploadedBomDataItems){
      var lineItems={
        'itemNo': this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].item_num,
        'manufacturer':this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].manufacturer,
        'mpn':this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].mpn,
        'qtyperBoard':this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].quantity,
        'refDes':this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].ref_designators,
        'dni':this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].do_not_install == null ? "": this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].do_not_install
      }
      this.commonService.commonMainObj.allAvailableComponets.push(this.commonService.commonMainObj.uploadedBomDataItems[bomcheck]['imported'].mpn);
      finalBomLineItems.push(lineItems);
    }
    var finalCustomBomData:any = {
      "boardQuantity" :[this.commonService.commonMainObj.customQtyOfAssemblies] ,
      "items": finalBomLineItems
    }
    this.commonService.loadingShow();
    this.apiService.requestForCustomBomPricing(finalCustomBomData).subscribe((result:any) =>{
      this.commonService.loadingHide();
      this.commonService.commonMainObj.customBomPricingData = result;
      this.router.navigateByUrl('/customQuoteComponentProcurement');
    },err=>{
      this.commonService.loadingHide();
        console.log(err)
    });
  }

  bomAutoMapDataSessionChecked(sheetsData:any,content:any){
    this.sheetsArray = [];
    this.showNumberOfSheets = true;
    for(let sheetIndx in sheetsData){
      this.sheetsArray.push(sheetsData[sheetIndx])
    }
    if(this.sheetsArray.length == 1){
      // this.showNumberOfSheets = true;
      this.selectedSheetNum = '0';
      if(content != ''){
        this.bomFinalMapData('',content)
        //this.bomAutoMapScreen(content);
      }
      setTimeout(()=>{
        this.commonService.loadingHide();
      },1000);
    }else{
      this.showNumberOfSheets = false;
      if(content != ''){
        this.bomAutoMapScreen(content);
      }       
      this.commonService.loadingHide();
    }
  }

  bomAutoMapData(bomFile:any,content:any){
    this.commonService.sessionPortalLoad();
    this.bomFileData = bomFile;
    this.commonService.commonMainObj.bomFileData = bomFile;
    this.selectedSheetNum = '';
    this.commonService.commonMainObj.customS3BomId='';
    this.apiService.assemblyBomSheetsProcees(bomFile).subscribe((sheetsData:any) => {
      if(sheetsData.message != '' && sheetsData.message != undefined){
        this.commonService.loadingHide();
        this.commonService.alertCall('Error',sheetsData.message);
        return;
      } 
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.bomAutoMapDataSessionChecked(sheetsData,content);
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      }else{
        this.bomAutoMapDataSessionChecked(sheetsData,content);
      }
      this.commonService.commonMainObj.customS3BomId = sheetsData[0].uploadedFileName;
      let requestToCustomObj={
        "assemblyAdded": this.commonService.commonMainObj.customAssemblySelected ? 'Yes' : '',
        "BomName":{
          "fromDesignFile":this.checkBomAutoUploaded,
          "added": this.checkBomAutoUploaded == ''? this.commonService.commonMainObj.uploadedFile?.name+'|'+this.commonService.commonMainObj.customS3BomId :'',
          "changed":this.bomChanged == true? this.commonService.commonMainObj.uploadedFile?.name+'|'+this.commonService.commonMainObj.customS3BomId : ''
        }
      }
      this.apiService.updateDetailsToDashboard(this.flowActivityId,requestToCustomObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas)=>{
        });
    },error => {
      this.commonService.loadingHide();
      console.log(error);
    })
  }

  bomFinalMapData(bomFile:any,content:any){
    this.apiService.assemblyBomProcees(this.bomFileData,this.selectedSheetNum).subscribe((data:any) => {
      this.commonService.loadingHide();
      if(data.error){
        setTimeout(() => {
          this.commonService.alertCall('Warning!',data.error);
          return false;
        },800);
      }else{
        if(content){
          this.bomAutoMapScreen(content);
        }
      }
      this.autoMappingData = '';
      this.mainRowArrayObj = {
        'labelsArray' : [],
        'bomOneMapArrayData' : []
      };
      data['columnheaderMapIndex']['item_num']= data['columnheaderMapIndex']['item_num'] || data['columnheaderMapIndex']['item_num'] == 0?data['columnheaderMapIndex']['item_num']:null;
      data['columnheaderMapIndex']['manufacturer_part_number']= data['columnheaderMapIndex']['manufacturer_part_number'] || data['columnheaderMapIndex']['manufacturer_part_number'] == 0?data['columnheaderMapIndex']['manufacturer_part_number']:null;
      data['columnheaderMapIndex']['reference_designators']= data['columnheaderMapIndex']['reference_designators'] || data['columnheaderMapIndex']['reference_designators'] == 0?data['columnheaderMapIndex']['reference_designators']:null;
      data['columnheaderMapIndex']['quantity']= data['columnheaderMapIndex']['quantity'] || data['columnheaderMapIndex']['quantity'] == 0?data['columnheaderMapIndex']['quantity']:null;
      this.autoMappingData = data;
      this.commonService.commonMainObj.bomProcessXlData = data;
      for(let dataIndex in this.autoMappingData['columnheaderMapIndex']){
        let displayName:any = dataIndex == 'item_num'?'Item Number':dataIndex == 'quantity'?'Quantity':dataIndex == 'reference_designators'?'Reference designator': dataIndex == 'manufacturer_part_number'?'MPN': dataIndex == 'manufacturer'?'Manufacturer':dataIndex == 'description'?'Description':dataIndex == 'value' ? 'Value':dataIndex == 'do-not-install'?'DNI':dataIndex == 'vendor_part_number'?'Part Number':dataIndex == 'footprint'?'Footprint':dataIndex;
          let labelObj = {
            'labelName' : displayName,
            'labelType':'existing',
            'selectedName1' : this.autoMappingData['columnheaderMapIndex'][dataIndex] != null ?parseInt(this.autoMappingData['columnheaderMapIndex'][dataIndex]):'',
            'mainlabelData': this.autoMappingData['columnheaderMapIndex'][dataIndex] != null ?parseInt(this.autoMappingData['columnheaderMapIndex'][dataIndex]):'',
            'mainLabelName' : dataIndex
          }
          this.mainRowArrayObj['labelsArray'].push(labelObj);
      }

      for(let bomDataIndex in this.autoMappingData['rowHeaderBOMData']){
        let dropDownDataObj = {
          'labelValue' : this.autoMappingData['rowHeaderBOMData'][bomDataIndex],
          'labelIndx' : bomDataIndex,
          'selectedObj' : bomDataIndex
        }
        this.mainRowArrayObj['bomOneMapArrayData'].push(dropDownDataObj);
      }
      this.showNumberOfSheets = true;
      setTimeout(() => {
        this.checkIfAllOptionsPresent();
      }, 500);
    },error => {
      if(error.status == 400){
        this.commonService.showtoast(error.error.error,'warning');
      }
      this.commonService.loadingHide();
      console.log(error);
    })
  }

  bomAutoMapScreen(screenCntnt:any){
    this.commonService.formattingCurrentDateTime();
    var bomAutoMapObj={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,bomAutoMapObj,'BOMColumnPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
      });
    this.modalService.open(screenCntnt, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;  
    }, (reason) => {
      console.log(reason);
    })
  }
  
  reQuoteValueCheck(){
    if(this.newPcbOrgTurnTime.includes("Weeks")){
      this.changedPcbTT =  this.newPcbOrgTurnTime.replace("Weeks", "");
      this.changedPcbTT =this.changedPcbTT*5;
    }else if(this.newPcbOrgTurnTime.includes("Week")){
      this.changedPcbTT =   this.newPcbOrgTurnTime.replace("Week", "");
      this.changedPcbTT =this.changedPcbTT*5;
    }else{
      this.changedPcbTT = this.newPcbOrgTurnTime.split(' ')[0]
    }
    // if(this.newAssemblyQty){
    //   if(this.newAssemblyTurnTime.includes("Weeks")){
    //     this.changedAssmblTT =  this.newAssemblyTurnTime.replace("Weeks", "");
    //     this.changedAssmblTT =this.changedAssmblTT*5;
    //   }else if(this.newAssemblyTurnTime.includes("Week")){
    //     this.changedAssmblTT =   this.newAssemblyTurnTime.replace("Week", "");
    //     this.changedAssmblTT =this.changedAssmblTT*5;
    //   }else{
    //     this.changedAssmblTT = this.newAssemblyTurnTime.split(' ')[0]
    //   }
    // }
  }

  reQuoteSessionChecked(pdType:any,content:any,gnqYn:any,res:any){
    if(res.BomId){
      this.commonService.commonMainObj.backToCppFromQuotePage = false;
      this.commonService.commonMainObj.backToCPPPage = true;
      this.commonService.commonMainObj.finalBomDataToPurchase.bomId = res.BomId
      this.commonService.commonMainObj.wmqId = res.wmqID
      this.commonService.commonMainObj.selectedFabQuantity = this.newPcbQty;
      this.commonService.commonMainObj.selectedFabTurntimeVal = this.newPcbOrgTurnTime.split(' ')[0];
      this.commonService.commonMainObj.selectedFabOrgTurntime = this.newPcbOrgTurnTime
      this.commonService.commonMainObj.qtyAssemblies = this.newAssemblyQty
      this.commonService.commonMainObj.selectedAssemblyTurntime = this.newAssemblyTurnTime;
      $('#quote-display-tbody').html('');
      this.commonService.commonMainObj.pcbType = pdType == ''?'Web PCB':pdType == 'SSP1'?'Product 1':'Product 2';
      this.router.navigateByUrl('/componentProcurement');
    }else if(res.errorMessage){
      if(res.errorMessage.indexOf('complexity') >0){
        if(this.changedPcbTT == 1){
          this.commonService.notificationAlert('Info!!','Based on the complexity of your board, a 1 day PCB or 1 day assembly turn time is not feasible. <br/>Please choose another turn time from the available options');
          return false;
        }else if(this.newAssemblyTurnTime && this.newAssemblyTurnTime.split(' ')[0] == 1){
          this.commonService.notificationAlert('Info!!','Based on the complexity of your board, 1 day assembly turn time is not feasible. <br/>Please choose another turn time from the available options');
          return false;
        }else{
          this.toCustomQuote('');
        }
      }else{
        this.commonService.alertCall('Alert!!',res.errorMessage);
      }
    }else if(res['Quote is available for the given input']){
      this.newChangeQuoteId = res['Quote is available for the given input']
      this.commonService.commonMainObj.pcbType = pdType == ''?'Web PCB':pdType == 'SSP1'?'Product 1':'Product 2';
      this.changeQuoteFn(content);
    }else if(res['reQuoteNumber']){
      this.newChangeQuoteId = res['reQuoteNumber'];
      this.commonService.commonMainObj.pcbType = pdType == ''?'Web PCB':pdType == 'SSP1'?'Product 1':'Product 2';
      this.changeQuote();
    }
  }

  
  reQuoteGuestCheck(content:any){
    this.commonService.sessionPortalLoad();
    if(this.commonService.commonMainObj.onlyPcb == false){
      if(this.newAssemblyQty && this.newPcbQty){
        if(parseInt(this.newAssemblyQty) > parseInt(this.newPcbQty)){
          this.commonService.alertCall('Alert!!','Assembly Labor Quantity must be less than or equal to PCB Fabrication Quantity');
          return false;
        }
      }else{
        this.commonService.alertCall('Alert!!','Assembly Labor Quantity and PCB Fabrication Quantity is required');
        return false;
      }
    }else{
      if(!this.newPcbQty){
        this.commonService.alertCall('Alert!!','PCB Fabrication Quantity is required');
        return false;
      }
    }
    if(this.commonService.commonMainObj.onlyPcb == false){
      if(isNaN(this.newPcbQty) || isNaN(this.newAssemblyQty)){
        this.commonService.alertCall('Alert!!','Please enter numeric value for Quantity');
        return false;
      }else{
        if(this.newPcbQty <=0 || this.newAssemblyQty <=0){
          this.commonService.alertCall('Alert!!','Quantity should be greater than 0');
          return false;
        }
      }
    }else{
      if(isNaN(this.newPcbQty)){
        this.commonService.alertCall('Alert!!','Please enter numeric value for Quantity');
        return false;
      }else{
        if(this.newPcbQty <=0){
          this.commonService.alertCall('Alert!!','Quantity should be greater than 0');
          return false;
        }
      }
    }
    this.commonService.sessionPortalLoad();
    if(this.commonService.commonMainObj.isGuestUser == true){
      this.commonService.commonMainObj.guestEventType = 'reQuote';
      this.commonService.commonMainObj.newPcbQty = this.newPcbQty;
      this.commonService.commonMainObj.newPcbOrgTurnTime = this.newPcbOrgTurnTime;
      if(this.commonService.commonMainObj.onlyPcb == false){
        this.commonService.commonMainObj.newAssemblyQty = this.newAssemblyQty;
        this.commonService.commonMainObj.newAssemblyTurnTime = this.newAssemblyTurnTime;
      }
      if(this.commonService.commonMainObj.uploadedFile){
        var formToSaveBomData = new FormData();
        if(this.commonService.commonMainObj.bomFileData.body){
          this.commonService.commonMainObj.uploadedFile = this.commonService.commonMainObj.uploadedFile.body
          this.commonService.commonMainObj.bomFileData = this.commonService.commonMainObj.bomFileData.body
        }
        formToSaveBomData.append('file', this.commonService.commonMainObj.retrivedBomFileDta == ''?this.commonService.commonMainObj.bomFileData:this.commonService.commonMainObj.retrivedBomFileDta);
        formToSaveBomData.append('emailId', this.commonService.commonMainObj.email);
        // console.log("this.commonService.commonMainObj.bomFileData",this.commonService.commonMainObj.bomFileData);
        this.commonService.commonMainObj.tryToSigninOrRegister = true;
        this.apiService.saveTheBomFile(formToSaveBomData).subscribe((data) =>{
          if (data) {
            this.commonService.commonMainObj.savedBomFileName = data.filename;
            this.commonService.commonMainObj.reQuoteContentObj = content;
            this.apiService.saveAppData().subscribe((appDataObj) =>{
              localStorage.setItem('apDtId','')
              localStorage.setItem('apDtId',appDataObj.id);
              if( this.commonService.commonMainObj.newUser == false){
                var redirectUrl = this.apiService.portalUrl + 'customer-portal/login/?src='+this.apiService.stagOneflowUrl+'/quoteDetails?fileId='+ localStorage.getItem('fileId');
                this.emailConfirmAlert('You need to sign-in to re-quote. You will be redirected to login page now, please enter the email id provided earlier in this flow, else you will not be able to re-quote successfully.',redirectUrl);
                this.commonService.commonMainObj.tryToRegister = false;
              }else{
                this.commonService.commonMainObj.tryToRegister = true;
                var redirectUrl = this.apiService.portalUrl + 'customer-portal/signup/?src='+this.apiService.stagOneflowUrl+'/quoteDetails?fileId='+ localStorage.getItem('fileId')+'&wqID='+this.commonService.commonMainObj.wqId+'&email='+this.commonService.commonMainObj.email
                this.emailConfirmAlert('',redirectUrl);
              }
            }, error =>{
              console.log('Bom file saving Error2', error);
            })
          }
        }, error =>{
          console.log('Bom file saving Error2', error);
        })
      }else{
        this.commonService.commonMainObj.tryToSigninOrRegister = true;
        this.commonService.commonMainObj.reQuoteContentObj = content;
        this.apiService.saveAppData().subscribe((appDataObj) =>{
          localStorage.setItem('apDtId','')
          localStorage.setItem('apDtId',appDataObj.id);
          if( this.commonService.commonMainObj.newUser == false){
            var redirectUrl = this.apiService.portalUrl + 'customer-portal/login/?src='+this.apiService.stagOneflowUrl+'/quoteDetails?fileId='+ localStorage.getItem('fileId');
            this.emailConfirmAlert('You need to sign-in to re-quote. You will be redirected to login page now, please enter the email id provided earlier in this flow, else you will not be able to re-quote successfully.',redirectUrl);
            this.commonService.commonMainObj.tryToRegister = false;
          }else{
            this.commonService.commonMainObj.tryToRegister = true;
            var redirectUrl = this.apiService.portalUrl + 'customer-portal/signup/?src='+this.apiService.stagOneflowUrl+'/quoteDetails?fileId='+ localStorage.getItem('fileId')+'&wqID='+this.commonService.commonMainObj.wqId+'&email='+this.commonService.commonMainObj.email
            this.emailConfirmAlert('',redirectUrl);
          }
        }, error =>{
          console.log('Bom file saving Error2', error);
        })
      }
    }else{
      this.reQuote(content);
    }
  }

  reQuote(content:any){
    localStorage.setItem('apDtId','');
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.loadingShow();
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          this.commonService.loadingHide();
          if(data.status == 1){
            this.reQuoteWithSessionCheck(content);
          }
        },error =>{
          console.log('Error in checking user session', error);
        })
      },1500);
    }else{
      this.reQuoteWithSessionCheck(content);
    }
    setTimeout(()=>{
      let requoteObj ={
        "reQuoted":"Yes"
      };
      this.apiService.updateDetailsToDashboard(this.flowActivityId,requoteObj,'ConfirmQuoteRequestPage').subscribe((resDatas)=>{
      },err=>{
        console.log(err)
      });
    },1600);
  }

  reQuoteWithSessionCheck(content:any){
    if(this.commonService.commonMainObj.pcbType != 'Web PCB'){
      this.reQuoteValueCheck();
      this.commonService.loadingShow();
      this.apiService.checkProductType(this.commonService.commonMainObj.boardDetailsDataObj,this.newAssemblyQty,this.newPcbQty,this.changedPcbTT,this.newAssemblyQty?this.newAssemblyTurnTime.split(' ')[0]:'').subscribe((data: any)=>{
        if(data.type == ''){
          if(this.commonService.commonMainObj.pcbType == 'Web PCB'){
            this.quoteChangeAPiFn(data.type,content,'');
          }else if(this.commonService.commonMainObj.pcbType == 'Product 1'){
            this.ssp1ToWebPcb(data.type,content);
          }else if(this.commonService.commonMainObj.pcbType == 'Product 2'){
            this.quoteChangeAPiFn(data.type,content,'');
          }
        }else if(data.type == 'SSP1' || data.type == 'SSP2'){
          if(this.commonService.commonMainObj.pcbType == 'Web PCB'){
            this.quoteChangeAPiFn(data.type,content,'');
          }else if(this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'){
            this.quoteChangeAPiFn(data.type,content,'');
          }
        }else if(data.type == null || data.type == 'Custom-Quote'){
          // if(this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1'){
          //   this.quoteChangeAPiFn(data.type,content,'');
          // }else 
          if(this.commonService.commonMainObj.pcbType == 'Product 2'){
            if(this.changedPcbTT == 1){
              this.commonService.notificationAlert('Info!!','Based on the complexity of your board, a 1 day PCB or 1 day assembly turn time is not feasible. <br/>Please choose another turn time from the available options');
              return false;
            }else if(this.newAssemblyTurnTime && this.newAssemblyTurnTime.split(' ')[0] == 1){
              this.commonService.notificationAlert('Info!!','Based on the complexity of your board, 1 day assembly turn time is not feasible. <br/>Please choose another turn time from the available options');
              return false;
            }else{
              this.toCustomQuote(' Allowed quantities are only 5 and 10.');
            }
          }
        }
      },error =>{
        console.log('Error in checking user session', error);   
      })
    }else{
      this.reQuoteValueCheck();
      this.commonService.loadingShow();
      this.quoteChangeAPiFn('',content,'');
    }
  }

  quoteChangeAPiFn(pdType:any,content:any,gnqYn:any){
    this.commonService.sessionPortalLoad();
    let dataObj:any = {
      "newPcbQuantity": this.newPcbQty,
      "newPcbTurntime": this.changedPcbTT,
      "proceedEvenIfOldQuoteIsAvailable":gnqYn?true:false,
      "productType": pdType
    }
      dataObj["newAssemblyQuantity"] = this.newAssemblyQty?this.newAssemblyQty:''
      dataObj["newAssemblyTurntime"] = this.newAssemblyQty?this.newAssemblyTurnTime.split(' ')[0]:''
    this.apiService.reQuoteCheck(dataObj,this.commonService.commonMainObj.wqId).subscribe((reqRes: any)=>{
      this.commonService.loadingHide();
      this.modalService.dismissAll('');
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.reQuoteSessionChecked(pdType,content,gnqYn,reqRes);
            }
          },error =>{
            console.log('Error in checking user session', error);
          })
      }else{
        this.reQuoteSessionChecked(pdType,content,gnqYn,reqRes);
      }
    },error =>{
      this.commonService.loadingHide();
      console.log('Error in checking user session', error);   
    })
  }

  changeQuoteFn(content:any){
    let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, backdrop:false,windowClass:'modal_change_quote'})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  checkIfAllOptionsPresent(){
    let allValuesSelected = true;
    $('.header-mapping-dropdown').each(function() {
      if ($(this).val() == '' && $(this).hasClass('requiredField')) {
        allValuesSelected = false;
        return false;
      }
    });
    if (allValuesSelected) {
      this.disableAutomapProceed = false;
    }else{
      this.disableAutomapProceed = true;
    }
  }

  proceedAutoMapData(){
    if(this.disableAutomapProceed == true){
      this.commonService.showtoast('Please map all mandatory columns to proceed','warning');
      return false;
    }else{
      let itemNumberCheck = this.autoMappingData['columnheaderMapIndex']['item_num'] == 0 ? this.autoMappingData['columnheaderMapIndex']['item_num']+'':this.autoMappingData['columnheaderMapIndex']['item_num'] == null?'':this.autoMappingData['columnheaderMapIndex']['item_num'];
      let quantityCheck = this.autoMappingData['columnheaderMapIndex']['quantity'] == 0 ? this.autoMappingData['columnheaderMapIndex']['quantity']+'':this.autoMappingData['columnheaderMapIndex']['quantity'] == null?'':this.autoMappingData['columnheaderMapIndex']['quantity'];

      if(itemNumberCheck && quantityCheck != ''){
        for(let lbleIndx in this.mainRowArrayObj['labelsArray']){
          if(this.mainRowArrayObj['labelsArray'][lbleIndx]['labelName'] =='Item Number'){
            if(itemNumberCheck != '' && itemNumberCheck != $('#columnMap_'+lbleIndx).val()){
              this.commonService.showtoast('Please map correct value to Item Number column','warning');
              return false;
            }
          }else if(this.mainRowArrayObj['labelsArray'][lbleIndx]['labelName'] =='Quantity'){
            if(quantityCheck !='' && quantityCheck != $('#columnMap_'+lbleIndx).val()){
              this.commonService.showtoast('Please map correct value to Quantity column','warning');
              return false;
            }
          }
        }
      }else{
        let msggs = '';
        if(!itemNumberCheck && !quantityCheck){
          msggs = 'Item Number and Quantity columns';
        }else if(!itemNumberCheck){
          msggs = 'Item Number column';
        }else if(!quantityCheck){
          msggs = 'Quantity column';
        }
        this.commonService.showtoast(msggs +' is missing in the uploaded BOM file. Please re-uploud new BOM with all mandatory columns.','warning');
        return false;
      }
      this.commonService.commonMainObj.bomProcessData['bom_id'] = null
      this.commonService.commonMainObj.bomProcessData['user_id'] = this.commonService.commonMainObj.userData.userId?this.commonService.commonMainObj.userData.userId:null;
      this.commonService.commonMainObj.bomProcessData['project_id'] = this.commonService.commonMainObj.fileUploadedData['projectId'];
      this.commonService.commonMainObj.bomProcessData['row_mapping'] = {
        "header": this.commonService.commonMainObj.bomProcessXlData['headerRowNumber'],
        "data": this.commonService.commonMainObj.bomProcessXlData['dataRowNumber'],
        "lines": this.commonService.commonMainObj.bomProcessXlData['numberOfDataLineItems']
      };
      let labelsObj:any = {}
      for(let labelIdx in this.mainRowArrayObj['labelsArray']){
        labelsObj[this.mainRowArrayObj['labelsArray'][labelIdx]['mainLabelName']] = parseInt(this.mainRowArrayObj['labelsArray'][labelIdx]['selectedName1'])
      }
      this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex'] = labelsObj;
      this.commonService.commonMainObj.bomProcessData['column_mapping'] = {
        "description": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['description'],
        "do_not_install": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['do_not_install'],
        "footprint": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['footprint'],
        "item_num": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['item_num'],
        "mpn": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['manufacturer_part_number'],
        "quantity": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['quantity'],
        "ref_designators": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['reference_designators'],
        "tolerance": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['tolerance'],
        "value": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['value'],
        "vendor": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['vendor'],
        "vpn": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['vendor_part_number'],
        "manufacturer" : this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['manufacturer']
      },
      this.commonService.commonMainObj.bomProcessData['bom_properties']['bom_name'] = this.commonService.commonMainObj.uploadedFileFullPath
      this.commonService.commonMainObj.bomProcessData['file']['filename'] = this.commonService.commonMainObj.uploadedFileFullPath
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['name'] = this.commonService.commonMainObj.uploadedFile.name
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'] = [];
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'].push(this.commonService.commonMainObj.bomProcessXlData['rowHeaderData']);
      let newArray = this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'].concat(this.commonService.commonMainObj.bomProcessXlData['dataRowsList'])
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'] = newArray;
      let mindex=0;
      for(let cma of this.mainRowArrayObj['labelsArray']){
          if(cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'){
            mindex++;
            continue;
          }else if(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number'){
            this.mappingArray.push(cma.labelName);
            this.selectedColMapValList.push($('#columnMap_'+mindex).val())
            mindex++;
          }else if(!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')){
            this.mappingArray.push(cma.labelName);
            this.selectedColMapValList.push($('#columnMap_'+mindex).val())
            mindex++;
          }
          
      }

      for(let i=0; i<this.selectedColMapValList.length;i++){
        for(let crow of this.mainRowArrayObj['bomOneMapArrayData']){
        
          if(this.selectedColMapValList[i] == crow.selectedObj){
            this.mapValueArray.push(crow.labelValue);
          }
        }
      }
      this.bomMappingKeyObj = Object.fromEntries(this.mappingArray.map((key:any, index:any) => [key, this.mapValueArray[index]]));
      var bomColMappingObj ={
        "mapping":this.bomMappingKeyObj
      }
      this.apiService.updateDetailsToDashboard(this.flowActivityId,bomColMappingObj,'BOMColumnPage').subscribe((resDatas)=>{
      },err=>{
        console.log(err)
        });
      
      setTimeout(()=>{
        this.router.navigateByUrl('/bomPreProcess');
        this.modalService.dismissAll('Save click');
      },1000);
    }
  }

  proceedSheet(){
    if(this.selectedSheetNum){
      this.bomFinalMapData('','')
    }else{
      this.commonService.alertCall('Warning!','Please select sheet');
    }
  }

  changeQuote(){
    this.commonService.loadingShow();
    this.apiService.changeNewQuote(this.newChangeQuoteId).subscribe((resQtData: any)=>{
      this.commonService.loadingHide();
      this.commonService.commonMainObj.pcbFinalQuotedata['pcbFinalQuoteDetails'] = resQtData
      this.commonService.commonMainObj.wqId = resQtData.wqID
      this.commonService.commonMainObj.selectedFabQuantity = resQtData['quoteItems'][0]['quantity'];
      if(resQtData['quoteItems'][0]['turntime'] <= 5){
        this.commonService.commonMainObj.selectedFabTurntimeVal = resQtData['quoteItems'][0]['turntime'];
        this.commonService.commonMainObj.selectedFabOrgTurntime = resQtData['quoteItems'][0]['turntime'] == 1?resQtData['quoteItems'][0]['turntime']+' Day':resQtData['quoteItems'][0]['turntime']+' Days'
      }else{
        let weeksVal = resQtData['quoteItems'][0]['turntime']/5
        this.commonService.commonMainObj.selectedFabTurntimeVal = weeksVal;
        this.commonService.commonMainObj.selectedFabOrgTurntime = weeksVal+' Weeks';
      }
      if(this.newAssemblyQty){
        this.commonService.commonMainObj.selectedAssemblyTurntime = resQtData['quoteItems'][1]['turntime'] == 1?resQtData['quoteItems'][1]['turntime']+' Day':resQtData['quoteItems'][1]['turntime']+' Days';
        this.commonService.commonMainObj.selectedAssemblyQuantity = resQtData['quoteItems'][1]['quantity'];
      }
      $('#quote-display-tbody').html('');
      this.modalService.dismissAll();
      this.initFn();
      window.scrollTo(0, 0);
    },error =>{
      this.commonService.loadingHide();
      console.log('Error in checking user session', error);   
    })
  }

  ssp1ToWebPcb(dataType:any,content:any){
    this.commonService.loadingHide();
    let msg = '';
    if(this.newAssemblyQty){
      msg = 'For your board specifications, our best price is available for quantities of either 5 or 10. Are you sure you want to update the PCB quantity to '+ this.newPcbQty + ' and Assembly quantity to ' + this.newAssemblyQty
    }else{
      msg = 'For your board specifications, our best price is available for quantities of either 5 or 10. Are you sure you want to update the PCB quantity to '+ this.newPcbQty
    }
    this.commonService.confirmAlertFn(msg).then((result:any) => {
      if (result.isConfirmed) {
        this.commonService.loadingShow();
        this.quoteChangeAPiFn(dataType,content,'');
        window.scrollTo(0, 0);
      } else if (result.isDismissed) {
        return false;
      }
    })
  }

  toCustomQuote(ssp2ToCustomQuoteMsg:any){
    this.commonService.loadingHide();
    this.commonService.bomConfirmAlert('<span class="p-2">Based on complexity of your board, we are unable to provide an online price for requested quantity.'+ssp2ToCustomQuoteMsg+'</span> <br> <span class="p-2">If you wish to proceed with the requested quantity, you will be redirected to custom quote flow where your request will be reviewed offline.</span> <br> <b>Note: </b> Once you are redirected to custom quote flow, you will not be able to return to this quote page again. you will need to start allover again to generate an online quote.').then((result:any) => {
      if (result.isConfirmed) {
        this.commonService.commonMainObj.pcbType = 'Custom/Advanced PCB';
        let customReQuoteObj={
          "redirectedToCustomQuote":'Yes',
        }
        this.apiService.updateDetailsToDashboard(this.flowActivityId,customReQuoteObj,'ConfirmQuoteRequestPage').subscribe((resDatas:any)=>{
          this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId;
        });
        this.commonService.commonMainObj.maxBoardQuantity = this.newPcbQty
        if(this.newPcbOrgTurnTime.split(' ')[1] == 'Weeks'){
          this.quoteDetailList.pcbTurnTime = parseInt(this.newPcbOrgTurnTime.split(' ')[0])*5
        }else{
          this.quoteDetailList.pcbTurnTime = parseInt(this.newPcbOrgTurnTime.split(' ')[0]);
        }
        if(this.newAssemblyQty){
          this.quoteDetailList.customaAssemblyTurnTime = parseInt(this.newAssemblyTurnTime.split(' ')[0]);
        }else{
          this.quoteDetailList.customaAssemblyTurnTime = this.quoteDetailList.pcbTurnTime
        }
        this.commonService.commonMainObj.reQuoteCheck = true;
        setTimeout(()=>{
          this.initFn();
        },500);
        if(this.commonService.commonMainObj.onlyPcb == false){
          setTimeout(()=>{
            $("#assemblyYes").trigger('click');
            setTimeout(()=>{
              if(this.commonService.commonMainObj.assemblySides == '2 side'){
                $('#numberOfSidesTwo').trigger('click');
              }else{
                $('#numberOfSidesOne').trigger('click');
              }
              if(this.commonService.commonMainObj.leadFreeProcessing == 'Yes'){
                $('#leadFreeYes').trigger('click');
              }else{
                $('#leadFreeNo').trigger('click');
              }
              if(this.commonService.commonMainObj.viaInPadData == 'Yes'){
                $('#viaInPadsYes').trigger('click');
              }else{
                $('#viaInPadsNo').trigger('click');
              }
            },500);
          },500);
        }
        window.scrollTo(0, 0);
      } else if (result.isDismissed) {
        return false;
      }
    })
  }

  openBomUnResolveList(content:any){
    let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, backdrop:false,windowClass:'modal_unresolve_quote'});
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  generateQuote(){
    this.commonService.loadingShow();
    this.quoteChangeAPiFn(this.commonService.commonMainObj.pcbType == 'Web PCB'?'':this.commonService.commonMainObj.pcbType == 'Product 1'?'SSP1':'SSP2','','gnq');
  }

  newPCBQtyChnge(){
    if(this.commonService.commonMainObj.onlyPcb == false){
      this.newAssemblyQty = this.newPcbQty
    }
  }
}
